// import { moveFile, path, loc } from '../../services/fileOps'
// import env from '../../services/env'
import {genId} from '../utils'
import {ControlManagerContainerContent} from '../ControlManager/container/content'
import {rootHydrate} from '../ControlManager/scripts/translation'
// const {DROPDIR} = envs\zsz

// import update from 'immutability-helper'
// import * as typeDirs from '../Data/typeDirs'

const NO_NAME = 'UCM'
const NO_TYPE = 'UCM'
const NO_EXT = 'ucm.json'

export class BasicManagedFile {
  constructor(data) {
    this._id = genId()
    this.name = NO_NAME
    this.typeDir = BasicManagedFile.getTypeDir()
    this.ext = BasicManagedFile.getExt()
    this.version = 0
    this.content = null
    this.modified = null
    this.created = Date.now()
    this.locked = ''
    this.getValue = function () {}
    this.setValue = function () {}
    this.getSource = function () {}
    this.setSource = function () {}
    this._modifiedBy = null
    this._createdBy = null
    this._versions = []
    this._includeStrings = []
    this._loaded = true
    if (data) {
      this.construct(data)
    }
  }

  static getTypeDir() {
    return NO_TYPE
  }

  static getIndices() {
    return '_id,name,[_id+name],type,version'
  }

  static getExt() {
    return NO_EXT
  }

  wrapVersion(patch, isBackup = false) {
    const {_id, version, typeDir} = this
    return {
      _id: genId(),
      patch,
      isBackup,
      typeDir,
      _parentId: _id,
      _createdBy: '',
      created: Date.now(),
      version: parseInt(version, 10) + 1,
    }
  }

  identifier(withVersion) {
    const res = {
      _id: this._id,
      name: this.name,
    }
    if (withVersion) {
      res.version = this.version
    }
    return res
  }

  getDelta(data) {
    // console.log('get delta', data)
    // console.log(this, this.content)
    let content = this.content.getDelta(data.content)
    return content
  }

  applyVersion(versionData) {
    let content = this.content.setDelta(versionData.patch)
    this.content = content
    this.version = versionData.version
    return this
  }

  getStrings() {
    return this.content.getIncludeStrings()
  }

  getBlockNames() {
    return Object.keys(this.content.content)
  }

  async fetchIncludes(chosenSource, dest) {
    const strings = this.getStrings()
    // console.debug('got include strings', strings)
    if (!strings || !strings.length) {
      return this
    }
    this._includes = this._includes || {}
    for (const includeStr of strings) {
      const blocks = includeStr.split('==>')
      for (const block of blocks) {
        let {type, id, name, file, rawFile} = await rootHydrate(
          block,
          chosenSource,
        )
        // console.log('received %s %s', type, id)
        if (dest) {
          console.debug('putting include', type, file, dest)
          dest[type].put(rawFile)
        }
        this._includes[type] = this._includes[type] || {}
        this._includes[type][id] = file
        this._includes[type][name] = file
      }

      // console.log(`assinging include str ${includeStr} to file`, file)
    }
    return this
  }

  async hydrate(chosenSource, chosenDest){
    // console.time('hydrate')
    // console.log('hydrating with', chosenSource, chosenDest)
    await this.fetchIncludes(chosenSource, chosenDest)
    // console.log('completed include fetch', this._includes)
    console.debug('begin hydrate proper')
    this.content.hydrate(this._includes)
    console.debug('hydrated content with includes', this._includes)
    // console.log(`${this.name} (${this._id}) finished hydrating itself`)
    // console.timeEnd('hydrate')
    // console.log(this.content)
    return this
  }

  getIncludes() {
    return this._includes
  }

  construct(data) {
    // console.log('bmf construct', data)
    // console.log('basic disk file data keys: ', Object.keys(data).join(', '))
    // console.log('basic disk file generating with data', JSON.stringify(data, null, 2))
    let {
      _id,
      _createdBy,
      _modifiedBy,
      created,
      modified,
      name,
      typeDir,
      version,
      locked,
      ext,
    } = data
    let content = data.content
    // console.log('basic disk file content', typeof content)
    if (!content) {
      throw new Error(`All control managers (${typeDir}) require content`)
    }
    // console.log('generating managed content from data', content)
    let c = new ControlManagerContainerContent(content)
    this.getValue = c.getValue.bind(c)
    this.setValue = c.setValue.bind(c)
    this.getSource = c.getSource.bind(c)
    this.setSource = c.setSource.bind(c)
    this.content = c
    // console.log(this.content)
    this._id = _id || this._id
    this.name = name || this.name
    this.version = parseInt(version, 10) || this.version
    this.ext = ext || NO_EXT
    this.typeDir = typeDir || this.typeDir
    this.created = created || this.created
    this._createdBy = _createdBy || this._createdBy
    this.modified = modified || this.modified
    this._modifiedBy = _modifiedBy || this._modifiedBy
    this.locked = locked || this.locked
    return this
  }

  serialize() {
    let {
      _id,
      _createdBy,
      _modifiedBy,
      created,
      modified,
      name,
      typeDir,
      version,
      locked,
      ext,
    } = this
    let content = this.content && this.content.serialize()
    return {
      content,
      _id,
      _createdBy,
      _modifiedBy,
      created,
      modified,
      name,
      typeDir,
      version,
      locked,
      ext,
    }
  }
}

export function tryGetAttr(type, cb) {
  let attr = null
  try {
    attr = cb()
  } catch (e) {
    throw new Error(
      `BasicManagedFile: Class ${type} can't get attribute: ${e.message}`,
    )
  }
  return attr
}
